<template>
  <v-container v-if="presentation"
               fluid>
    <PageTitle>
      <div>
        <div class="text-caption">
          {{ presentation.name }}
        </div>
        <div>
          <v-icon left>
            fal fa-fw fa-sticky-note
          </v-icon>
          My Notes
        </div>
      </div>
      <template v-slot:buttons>
        <v-btn @click.prevent="deleteMyNotes"
               :disabled="notes.length === 0">
          Delete all notes
        </v-btn>
      </template>
    </PageTitle>

    <v-row v-if="pagesLoaded && notesLoaded">
      <v-col v-for="page in presentation.num_pages"
             :key="page"
             cols="12"
             lg="6"
             xl="4">
        <PresentationNoteCard :notes="notes"
                              :page="page"
                              :pages="pages"
                              :presentation="presentation"
                              :slides="slides"
                              class="mb-4"
                              @updated="fetchNotes">
        </PresentationNoteCard>
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss">
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px; /* Space between the columns */
}
</style>
<script>
import PageTitle from '../../components/PageTitle.vue';
import presentationService from '../../services/presentationService';
import presentationNoteService from '../../services/presentationNoteService';
import PresentationNoteCard from './components/PresentationNoteCard.vue';
import slideDeckService from '../../services/slideDeckService';

export default {
  components: {PresentationNoteCard, PageTitle},
  data() {
    return {
      presentation: null,
      notesLoading: false,
      notesLoaded: false,
      notes: [],
      pagesLoaded: false,
      pages: [],
      presentationSlides: [],
    }
  },
  computed: {
    presentationID() {
      return parseInt(this.$route.params.presentationID);
    },
    slides() {
      return this.presentationSlides.map(ps => ps.slide);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.presentation = await presentationService.getPresentation(this.presentationID);
      await this.fetchPages();
      await this.fetchNotes();
      await this.fetchSlides();
    },
    async fetchPages() {
      this.pagesLoaded = false;
      this.pages = await presentationService.getPageFilesFor(this.presentationID)
      this.pagesLoaded = true;
    },
    async fetchSlides() {
      this.presentationSlides = await slideDeckService.getPresentationSlidesFor(this.presentationID);
    },
    async fetchNotes() {
      this.notes = await presentationNoteService.getMyNotesForPresentation(this.presentationID);
      this.notesLoaded = true;
    },
    async deleteMyNotes() {
      if (confirm('Are you sure you want to delete all of your notes for this presentation?')) {
        await presentationNoteService.deleteMyNotesForPresentation(this.presentationID);
        this.notesLoaded = false;
        await this.fetchNotes();
        this.$toast.success('Notes deleted.');
      }
    }
  }
}
</script>
